import { Browser } from '@capacitor/browser';
import { OAuthConfig } from '@doka/identity-login';

export const environment = {
  production: false,
  stage: 'dev',
  baseUrlGroupIdentityAPI: 'https://login.test.doka.com',
  appId: '971e5de7-8d8e-4e85-7962-08ded2c62039',
  yardApiUrl: 'https://yard-api.dev.doka.com',
};

export const authCodeFlowConfig: OAuthConfig = {
  issuer: 'https://login.test.doka.com',
  strictDiscoveryDocumentValidation: false,
  clientId: 'e1e055f9-1046-4eea-a43d-7294da65cf5d',
  responseType: 'code',
  scope: 'openid profile email roles offline_access yard-api.doka.com/common.read',
  oidc: true,
  showDebugInformation: true,
  logoutUrl: 'https://login.test.doka.com/connect/endsession',
  tokenEndpoint: 'https://login.test.doka.com/connect/token',
  platformConfig: {
    mobile: {
      redirectUri: 'com.doka.returnsapdev://',
      postLogoutRedirectUri: 'com.doka.returnsapdev://logout',
      openUri: (uri) => Browser.open({ url: uri }),
    },
    web: {
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin + '/logout',
    },
  },
};
